import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholder Analysis',
      type: 'table',
      alias: 'stakeholder-analysis-table log',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.stakeholder',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'records',
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'isProjectTeamMember',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!is_project_team_member',
                              },
                              {
                                '``': {
                                  '@$': 'isProjectTeamMember',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'projectRole',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!project_role',
                              },
                              {
                                '``': {
                                  '@$': 'projectRole',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'degreeOfImpact',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!degree_of_impact',
                              },
                              {
                                '``': {
                                  '@$': 'degreeOfImpact',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'influenceDecisionRole',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!influence_decision_role',
                              },
                              {
                                '``': {
                                  '@$': 'influenceDecisionRole',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'changeChampion',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!change_champion',
                              },
                              {
                                '``': {
                                  '@$': 'changeChampion',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'engagementNeeded',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!engagement_needed',
                              },
                              {
                                '``': {
                                  '@$': 'engagementNeeded',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'validationStatus',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!validation_status',
                              },
                              {
                                '``': {
                                  '@$': 'validationStatus',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'understanding',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!understanding',
                              },
                              {
                                '``': {
                                  '@$': 'understanding',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'perceivedAttitude',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!perceived_attitude',
                              },
                              {
                                '``': {
                                  '@$': 'perceivedAttitude',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'trainingAudienceNeed',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': '!training_audience_need',
                              },
                              {
                                '``': {
                                  '@$': 'trainingAudienceNeed',
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!name',
                },
              },
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'isProjectTeamMember',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!is_project_team_member',
                          },
                          {
                            '``': {
                              '@$': 'isProjectTeamMember',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'projectRole',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!project_role',
                          },
                          {
                            '``': {
                              '@$': 'projectRole',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'degreeOfImpact',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          {
                            '``': {
                              '@$': 'degreeOfImpact',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'influenceDecisionRole',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          {
                            '``': {
                              '@$': 'influenceDecisionRole',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'changeChampion',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!change_champion',
                          },
                          {
                            '``': {
                              '@$': 'changeChampion',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'engagementNeeded',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!engagement_needed',
                          },
                          {
                            '``': {
                              '@$': 'engagementNeeded',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'validationStatus',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!validation_status',
                          },
                          {
                            '``': {
                              '@$': 'validationStatus',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'understanding',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!understanding',
                          },
                          {
                            '``': {
                              '@$': 'understanding',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'perceivedAttitude',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!perceived_attitude',
                          },
                          {
                            '``': {
                              '@$': 'perceivedAttitude',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'trainingAudienceNeed',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!training_audience_need',
                          },
                          {
                            '``': {
                              '@$': 'trainingAudienceNeed',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!stakeholders:!stakeholder',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      persona: {
                        '{}': {
                          value: {
                            '@': 'persona',
                          },
                        },
                      },
                      projectRole: {
                        '{}': {
                          value: {
                            '@.': '!project_role',
                          },
                        },
                      },
                      jobTitleRole: {
                        '{}': {
                          value: {
                            '@': 'jobTitle',
                          },
                        },
                      },
                      supportNeeds: {
                        '{}': {
                          value: {
                            '@.': '!support_needs',
                          },
                        },
                      },
                      managerLeader: {
                        '{}': {
                          value: {
                            '@': 'manager',
                          },
                        },
                      },
                      notesFollowUp: {
                        '{}': {
                          value: {
                            '@.': '!notes_follow_up',
                          },
                        },
                      },
                      understanding: {
                        '{}': {
                          color: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!understanding',
                                    },
                                    'Low',
                                  ],
                                },
                                '#CD4643',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!understanding',
                                    },
                                    'Medium',
                                  ],
                                },
                                '#FBC02D',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!understanding',
                                    },
                                    'High',
                                  ],
                                },
                                '#3AA69B',
                              ],
                              null,
                            ],
                          },
                          value: {
                            '@.': '!understanding',
                          },
                        },
                      },
                      changeChampion: {
                        '{}': {
                          value: {
                            '@.': '!change_champion',
                          },
                        },
                      },
                      degreeOfImpact: {
                        '{}': {
                          color: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!degree_of_impact',
                                    },
                                    'Low',
                                  ],
                                },
                                '#CD4643',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!degree_of_impact',
                                    },
                                    'Medium',
                                  ],
                                },
                                '#FBC02D',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!degree_of_impact',
                                    },
                                    'High',
                                  ],
                                },
                                '#3AA69B',
                              ],
                              null,
                            ],
                          },
                          value: {
                            '@.': '!degree_of_impact',
                          },
                        },
                      },
                      departmentName: {
                        '{}': {
                          value: {
                            '@': 'department',
                          },
                        },
                      },
                      systemUserRole: {
                        '{}': {
                          value: {
                            '@.': '!system_user_role',
                          },
                        },
                      },
                      stakeholderName: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      engagementNeeded: {
                        '{}': {
                          value: {
                            '@.': '!engagement_needed',
                          },
                        },
                      },
                      validationStatus: {
                        '{}': {
                          value: {
                            '@.': '!validation_status',
                          },
                        },
                      },
                      perceivedAttitude: {
                        '{}': {
                          value: {
                            '@.': '!perceived_attitude',
                          },
                        },
                      },
                      subdepartmentName: {
                        '{}': {
                          value: {
                            '@': 'subdepartment',
                          },
                        },
                      },
                      isProjectTeamMember: {
                        '{}': {
                          value: {
                            '@.': '!is_project_team_member',
                          },
                        },
                      },
                      trainingAudienceNeed: {
                        '{}': {
                          value: {
                            '@.': '!training_audience_need',
                          },
                        },
                      },
                      communicationAudience: {
                        '{}': {
                          value: {
                            '@.': '!comm_audience',
                          },
                        },
                      },
                      influenceDecisionRole: {
                        '{}': {
                          color: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!influence_decision_role',
                                    },
                                    'Low',
                                  ],
                                },
                                '#CD4643',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!influence_decision_role',
                                    },
                                    'Medium',
                                  ],
                                },
                                '#FBC02D',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!influence_decision_role',
                                    },
                                    'High',
                                  ],
                                },
                                '#3AA69B',
                              ],
                              null,
                            ],
                          },
                          value: {
                            '@.': '!influence_decision_role',
                          },
                        },
                      },
                      potentialConcernsRisks: {
                        '{}': {
                          value: {
                            '@.': '!concerns_risks',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              goto: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      stakeholderId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                  navigationId: 'details',
                                },
                              },
                            },
                          },
                          operation: 'ui.navigate',
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                manager: {
                  ref: {
                    attr: 'attr:ent#!personnel_leaders#!relationship:!leader',
                  },
                  using: 'managerRelationship',
                  target: 'ent:!personnel:!employee',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                persona: {
                  ref: {
                    attr: 'attr:ent#!stakeholders#!stakeholder:!persona',
                  },
                  target: 'dim::!personas',
                  quantity: 1,
                  selection: {
                    '@.': '!id',
                  },
                },
                employee: {
                  ref: {
                    attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
                  },
                  target: 'ent:!personnel:!employee',
                },
                jobTitle: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!job_title',
                  },
                  using: 'employee',
                  target: 'ent:!job_titles:!job_title',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                department: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!org',
                  },
                  using: 'employee',
                  target: 'ent:!org:!subdept',
                  quantity: 1,
                  selection: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-advancement',
                          ],
                        },
                        'Advancement',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-athletics',
                          ],
                        },
                        'Athletics',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-finance-and-treasury',
                          ],
                        },
                        'Finance and Treasury',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-information-technology',
                          ],
                        },
                        'Information Technology',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-undergraduate-financial-aid',
                          ],
                        },
                        'Undergraduate Financial Aid',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-school-of-engineering-and-applied-science',
                          ],
                        },
                        'School of Engineering and Applied Science',
                      ],
                      null,
                    ],
                  },
                },
                subdepartment: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!org',
                  },
                  using: 'employee',
                  target: 'ent:!org:!subdept',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                managerRelationship: {
                  ref: {
                    attr: 'attr:ent#!personnel_leaders#!relationship:!personnel',
                  },
                  using: 'employee',
                  target: 'ent:!personnel_leaders:!relationship',
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'stakeholderName',
                  direct: {
                    '{}': {
                      name: 'Stakeholder Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'jobTitleRole',
                  direct: {
                    '{}': {
                      name: 'Job Title / Role',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'departmentName',
                  direct: {
                    '{}': {
                      name: 'Department',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'subdepartmentName',
                  direct: {
                    '{}': {
                      name: 'Subdepartment',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'persona',
                  direct: {
                    '{}': {
                      name: 'Persona',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'managerLeader',
                  direct: {
                    '{}': {
                      name: 'Manager / Leader',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'isProjectTeamMember',
                  direct: {
                    '{}': {
                      name: 'Project Team',
                      type: 'BOOL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'projectRole',
                  direct: {
                    '{}': {
                      name: 'Project Role',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_project_role',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'systemUserRole',
                  direct: {
                    '{}': {
                      name: 'System / User Role',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'degreeOfImpact',
                  direct: {
                    '{}': {
                      name: 'Degree of Impact',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'influenceDecisionRole',
                  direct: {
                    '{}': {
                      name: 'Influence / Decision Role',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'changeChampion',
                  direct: {
                    '{}': {
                      name: 'Change Champion',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_change_champion',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'engagementNeeded',
                  direct: {
                    '{}': {
                      name: 'Engagement Needed',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_engagement_needed',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'validationStatus',
                  direct: {
                    '{}': {
                      name: 'Validation Status',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_validation_status',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'understanding',
                  direct: {
                    '{}': {
                      name: 'Understanding',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'perceivedAttitude',
                  direct: {
                    '{}': {
                      name: 'Perceived Attitude',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_perceived_attitude',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'potentialConcernsRisks',
                  direct: {
                    '{}': {
                      name: 'Potential Concerns / Risks',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'supportNeeds',
                  direct: {
                    '{}': {
                      name: 'Support Needs',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'communicationAudience',
                  direct: {
                    '{}': {
                      name: 'Communication Audience',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'trainingAudienceNeed',
                  direct: {
                    '{}': {
                      name: 'Training Audience / Need',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_training_audience',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'notesFollowUp',
                  direct: {
                    '{}': {
                      name: 'Notes / Follow-Up',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'create.stakeholder.modal',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
